import TableWithCheckboxes from "../../../../../../../../ui/tables/table-with-checkboxes/TableWithCheckboxes";
import {headCells} from "../servizi-details-filter/ServiziDetailsFilterHelper";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import EmptyRow from "../../../../../../../../ui/tables/rows/empty-row/EmptyRow";
import {returnSelectedRows} from "../../../../../../../../../shared/utils/tableUtils";
import TagsCell from "../../../../../../sim/tabs/attive/attive-table/tags-cell/tags/Tags";
import React from "react";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";

const ServiziDetailsTable = (props) => {
    const tableData = useSelector(state => state.contrattoDigitaleReducer.apnSimTable.data.sims);
    const count = useSelector(state => state.contrattoDigitaleReducer.apnSimTable.data.totalElements);
    const loading = useSelector(state => state.contrattoDigitaleReducer.apnSimTable.loading);


    const handleCheckboxClick = (e, servizi) => {
        e.stopPropagation()
        const selectedIndex = props.selected.findIndex(s => s.id === servizi.id);
        props.setSelected(returnSelectedRows(props.selected, servizi, selectedIndex));
    }

    const isSelected = (id) => props.selected.some(servizi => servizi.id === id)
    const tableRows = (
        tableData.length !== 0 ? tableData
                .map((row, index) => {
                    const isItemSelected = isSelected(row.id)
                    const labelId = `servizi-table-checkbox-${index}`

                    return (
                        <TableRow key={row.id}
                                  hover
                                  selected={isItemSelected}
                                  role="checkbox"
                                  aria-checked={isItemSelected}
                                  tabIndex={-1}>
                            <TableCell padding="checkbox">
                                <Checkbox
                                    checked={isItemSelected}
                                    onClick={(e) => handleCheckboxClick(e, row)}
                                    inputProps={{'aria-labelledby': labelId}}
                                />
                            </TableCell>
                            <TableCell align="left">{row.msisdn}</TableCell>
                            <TableCell align="left">{row.iccid}</TableCell>
                            <TableCell align="left">{row.apnType}</TableCell>
                            <TableCell align="left">{row.apnName}</TableCell>
                            {row.tags ? <TableCell align="left"><TagsCell tags={row.tags}/></TableCell> : <TableCell/>}
                        </TableRow>
                    );
                }) :
            <EmptyRow text="dato" colSpan={headCells.length + 2}/>
    )
    return (
        <TableWithCheckboxes
            selectAllRows={props.areAllSelected}
            setSelectAllRows={props.setAreAllSelected}
            selected={props.selected}
            setSelected={props.setSelected}
            count={count}
            fetchData={props.handlePaginationChange}
            loading={loading}
            tableRows={tableRows}
            rows={tableData}
            headCells={headCells}
            rowsPerPage={props.rowsPerPage}
            page={props.page}/>
    )
}

ServiziDetailsTable.propTypes = {
    selected: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
    handlePaginationChange: PropTypes.func.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired
}

export default ServiziDetailsTable;